import en from './en';

const ptBR = {
  ...en,
  lang: 'pt-BR',
  langName: 'Português (Brasil)',
  flag: '🇧🇷',
  siteTitle: 'Simulado TOEFL iBT Grátis - Análise com IA | Power TOEFL 2026',
  siteDescription: 'Pratique simulados TOEFL 2026 gratuitamente. Análise por IA de Reading, Listening, Fala, Escrita, revisão de erros e conversão de pontuação.',
  ogTitle: 'Simulado TOEFL iBT Grátis - Análise com IA | Power TOEFL 2026',

  navGrammar: 'Gramática',
  navPractice: 'Prática por Seção',
  navScoreChart: 'Tabela de Pontos',
  navVocabulary: 'Vocabulário',
  navTips: 'Dicas e Estratégia',
  navQuestionPool: 'Banco de Questões',
  navResources: 'Recursos',
  navSpeaking: 'Fala',
  navWriting: 'Escrita',
  navPremium: 'Plano Pro',

  loginButton: 'Entrar',
  wrongAnswers: 'Caderno de Erros',
  logout: 'Sair',
  loginRequired: 'É necessário entrar para usar Caderno de Erros e Retomar.',
  googleLogin: 'Continuar com Google para liberar recursos premium',

  heroBadge: 'Sistema Premium de Estudo para TOEFL',
  heroTitle1: 'Uma Plataforma',
  heroTitle2: 'para Pontuação Alta no TOEFL',
  heroDesc1: 'De simulados completos das 4 seções à revisão personalizada de erros,',
  heroDesc2: 'tudo o que você precisa para alcançar sua meta.',

  lcSubtitle: 'Reading - 20 questões',
  lcTime: '35 min',
  rcSubtitle: 'Listening - 28 questões',
  rcTime: '36 min',
  startTest: 'Iniciar Teste',
  fullTestStart: 'Iniciar Simulado Completo (Reading -> Listening)',
  fullTestDesc: 'Conclua as duas seções em sequência',

  moreTools: 'Mais Ferramentas de Estudo',
  practiceLabel: 'Prática por Seção',
  practiceDesc: 'Treine Reading e Listening separadamente',
  scoreChartLabel: 'Conversão de Pontos',
  scoreChartDesc: 'Acertos para pontuação estimada',
  vocabDesc: 'Vocabulário essencial para TOEFL',
  tipsDesc: 'Estratégias de Listening e Reading',
  catDesc: 'Dificuldade ajustada automaticamente ao seu nível',
  guideLabel: 'Guia de Estudos',
  guideDesc: 'Estratégias por habilidade, planos por faixa de pontuação e comparativos de exames',
  fullTestCardLabel: 'Simulado Completo',
  fullTestCardDesc: 'Prática real de Reading + Listening',
  grammarSectionTitle: 'Livro de Gramática Inglesa',
  grammarSectionDesc: 'Estude a gramática essencial para o TOEFL de forma estruturada',
  grammarViewAll: 'Ver tudo',
  proBadgeLabel: 'Pro',

  statQuestions: 'Questões',
  statParts: 'Partes',
  statMinutes: 'Minutos',

  footerMockTest: 'Prática',
  footerQuestionPool: 'Banco de Questões',
  footerPractice: 'Prática por Seção',
  footerStudy: 'Estudo',
  footerBooks: 'Livros Recomendados',
  footerEtc: 'Mais',
  footerLC: 'Prática de Listening',
  footerRC: 'Prática de Reading',
  footerSpeaking: 'Prática de Fala',
  footerWriting: 'Prática de Escrita',
  footerLCStrategy: 'Estratégia de Listening',
  footerRCStrategy: 'Estratégia de Reading',

  faqTitle: 'Perguntas Frequentes',
  faqDesc: 'Veja respostas sobre TOEFL e Power TOEFL.',
  faqMore: 'Precisa de mais ajuda? Atualizamos este FAQ continuamente.',

  tipsLCPageTitle: 'Como aumentar a pontuação no TOEFL Listening | Rotina de treino LC - Power TOEFL',
  tipsLCPageDesc: 'Treino prático de TOEFL Listening para subir a pontuação em LC: anotações em Conversations e Lectures, inferência e atitude do falante.',
  tipsLCHeading: 'Estratégia de pontuação TOEFL Listening',
  tipsLCIntro: 'Estratégias essenciais e rotinas práticas para cada parte do TOEFL Listening.',
  tipsLCPractice: 'Praticar Listening agora',
  tipsLCPracticeDesc: 'Aplique a estratégia com um teste prático real.',
  tipsLCStartTest: 'Iniciar teste de Listening',
  tipsRCPageTitle: 'Estratégia de TOEFL Reading - Guia de textos acadêmicos | Power TOEFL',
  tipsRCPageDesc: 'Estratégia de TOEFL Reading para textos acadêmicos: gestão de tempo, inferência e abordagem de questões de resumo.',
  tipsRCHeading: 'Estratégia de TOEFL Reading',
  tipsRCIntro: 'Guia prático de estratégia de leitura e ritmo para TOEFL Reading.',
  tipsRCPractice: 'Praticar Reading agora',
  tipsRCPracticeDesc: 'Aplique a estratégia com um teste prático real.',
  tipsRCStartTest: 'Iniciar teste de Reading',
  tips7DayTitle: 'Plano intensivo de 7 dias',
  tips7DayDesc: 'Maximize sua pontuação com uma rotina focada na semana final',
  tipsTrapTitle: 'Guia de padrões de armadilha',
  tipsTrapDesc: 'Conheça com antecedência os 5 padrões de armadilha mais comuns',

  aboutPageTitle: 'Sobre o Power TOEFL - Simulados grátis e ferramentas de IA',
  aboutPageDesc: 'Pratique TOEFL com simulados completos, análise de pontos fracos por IA e revisão automática de erros.',
  aboutHeading: 'Power TOEFL - Plataforma prática de preparação para TOEFL',
  aboutS1Title: 'O que é o Power TOEFL?',
  aboutS1Body: 'O Power TOEFL é uma plataforma online gratuita para quem está se preparando para o TOEFL. Oferecemos simulados completos, prática com IA e revisão de erros.',
  aboutS2Title: 'Para quem é indicado?',
  aboutS2Body: 'Indicado para estudantes, profissionais e autodidatas que buscam prática estruturada para alcançar a pontuação desejada.',
  aboutS3Title: 'Principais recursos',
  aboutFeature1: 'Simulados completos no estilo TOEFL com várias rodadas',
  aboutFeature2: 'Prática focada em Reading, Listening, Speaking e Writing',
  aboutFeature3: 'Geração de questões por IA e análise de pontos fracos',
  aboutFeature4: 'Caderno de erros automático com revisão espaçada',
  aboutFeature5: 'Tabela de conversão de pontuação e vocabulário essencial',
  aboutS4Title: 'Diferença entre Free e Premium',
  aboutS4Body: 'O plano Free inclui simulados, prática por seção e tabela de pontuação. O Premium adiciona geração ilimitada por IA, sem anúncios e acesso completo aos simulados.',
  aboutS5Title: 'Por que a pontuação melhora',
  aboutS5Body: 'Com revisão espaçada, análise precisa de fraquezas e prática em ambiente realista, a consistência de desempenho no teste aumenta.',
  aboutS6Title: 'Relação com a ETS',
  aboutS6Body: 'O Power TOEFL é uma plataforma independente e não é afiliada nem endossada pela ETS. TOEFL é marca registrada da ETS.',
  aboutS7Title: 'Contato',
  aboutS7Body: 'Para dúvidas sobre o serviço, entre em contato por skdaks0731@gmail.com.',
  aboutCtaHeading: 'Comece hoje',
  aboutCtaDesc: 'Faça agora um teste prático gratuito de TOEFL.',
  aboutCtaStart: 'Começar simulado',
  aboutCtaPricing: 'Ver planos Premium',

  catPageTitle: 'TOEFL Adaptive Test (CAT) - Dificuldade automática por IA | Power TOEFL',
  catPageDesc: 'Teste adaptativo de prática TOEFL. A IA ajusta automaticamente a dificuldade das questões com base no seu desempenho.',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'A dificuldade se ajusta à sua taxa de acerto. {count} questões por sessão.',
  catNote: "ℹ️ Nota: O TOEFL iBT real é um teste linear (não adaptativo). Este Practice CAT é uma ferramenta de estudo que ajusta a dificuldade ao seu desempenho para você identificar seu nível rapidamente — não é uma simulação do formato real do exame.",
  catSelectSection: 'Selecionar seção',
  catStartBtn: 'Iniciar Adaptive Test',
  catLoading: 'Carregando próxima questão...',
  catNoMore: 'Não há mais questões disponíveis',
  catComplete: 'Adaptive Test concluído',
  catAccuracy: 'Precisão',
  catFinalLevel: 'Nível final',
  catTryAgain: 'Tentar novamente',
  catViewResults: 'Ver resultados',
  catNext: 'Próximo',
  catExplanation: 'Explicação',
  catStop: 'Parar',
  catPlayAudio: 'Reproduzir áudio',
  catReadingPassage: 'Texto de Reading',

  speakingPageH1: 'Prática de Speaking TOEFL 2026',
  speakingPageSub: '{count}+ prompts gratuitos de Speaking — Listen and Repeat e Interview',
  speakingPageTitle: 'Prática de Speaking TOEFL 2026 — {count}+ Prompts Grátis e Respostas Modelo | Power TOEFL',
  speakingPageDesc: '{count}+ prompts de Speaking TOEFL com respostas modelo, rubricas de pontuação e feedback por IA. Atualizado para 2026.',
  speakingAllTasks: 'Todos',
  speakingNoPrompts: 'Ainda não há prompts de Speaking',
  speakingNoPromptsSub: 'Os prompts estão sendo gerados. Volte em breve!',
  speakingResponseTime: 'Tempo de resposta',

  writingPageH1: 'Prática de Writing TOEFL 2026',
  writingPageSub: '{count}+ tarefas gratuitas de Writing — Build a Sentence, Email e Academic Discussion',
  writingPageTitle: 'Prática de Writing TOEFL 2026 — {count}+ Tarefas Grátis | Power TOEFL',
  writingPageDesc: '{count}+ tarefas de Writing TOEFL com respostas modelo e critérios de pontuação. Atualizado para 2026.',
  writingAllTasks: 'Todos',
  writingNoPrompts: 'Ainda não há prompts de Writing',
  writingNoPromptsSub: 'Os prompts estão sendo gerados. Volte em breve!',

  scoreChartHeading: 'Tabela de Conversão de Pontos TOEFL',
  scoreChartIntro: 'As tabelas de 0–30 por seção e total 0–120 são estimativas de estudo do Power TOEFL na escala antiga/comparável. Os relatórios oficiais de 2026 priorizam notas por seção e geral de 1–6 em incrementos de 0,5.',
  scoreChartLC: 'Conversão de Reading',
  scoreChartRC: 'Conversão de Listening',
  scoreChartCorrect: 'Acertos',
  scoreChartConverted: 'Pontuação Convertida',
  scoreChartPointUnit: 'pts',
  scoreGuideTitle: 'Guia de Pontuação Alvo',
  scoreGuide900: 'Nível Máximo',
  scoreGuide900Desc: 'Meta de 28+ por seção. Forte para admissões de topo.',
  scoreGuide800: 'Nível Alto',
  scoreGuide800Desc: 'Meta de 22+ por seção. Atende a maioria dos requisitos.',
  scoreGuide700: 'Intermediário Alto',
  scoreGuide700Desc: 'Base acadêmica atingida. Admissão condicional é possível.',
  scoreGuide600: 'Intermediário',
  scoreGuide600Desc: 'Foque primeiro nos fundamentos de Reading e Listening.',
  scoreGuideDescs: [
    'Recomendado: Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+. Forte para admissões de universidades de topo.',
    'Meta de Reading 22+ / Listening 22+. Atende a maioria dos requisitos de admissão.',
    'Base acadêmica alcançada. Admissão condicional pode ser possível com estudo focado.',
    'Nível fundamental. Priorize primeiro os fundamentos de Reading e Listening.',
  ],
  scoreChartFaqTitle: 'FAQ de Pontuação TOEFL',
  scoreChartCtaTitle: 'Confira seu nível agora',
  scoreChartCtaDesc: 'Faça um simulado TOEFL grátis e estime sua pontuação.',
  scoreReadingHeader: 'Reading (0-30 pts)',
  scoreListeningHeader: 'Listening (0-30 pts)',
  scoreSpeakingHeader: 'Fala (0-30 pts)',
  scoreWritingHeader: 'Escrita (0-30 pts)',
  scoreSpeakingDesc: '4 tarefas são avaliadas em escala de 0-4 e convertidas para 30 pontos',
  scoreWritingDesc: '2 tarefas são avaliadas em escala de 0-5 e convertidas para 30 pontos',
  scoreSpeakingLevels: [
    ['4 (Bom)', '27-30 pts', 'Resposta fluente e precisa, com boa organização lógica'],
    ['3 (Regular)', '19-26 pts', 'Majoritariamente clara, com alguns erros'],
    ['2 (Limitado)', '11-18 pts', 'Comunicação básica possível, mas limitada'],
    ['1 (Fraco)', '1-10 pts', 'Dificuldade para transmitir significado'],
  ],
  scoreWritingLevels: [
    ['5 (Bom)', '27-30 pts', 'Redação lógica e específica, com gramática correta'],
    ['4 (Regular)', '22-26 pts', 'No geral boa, mas com partes pouco desenvolvidas'],
    ['3 (Limitado)', '15-21 pts', 'Estrutura básica presente, porém com desenvolvimento fraco'],
    ['2 (Fraco)', '8-14 pts', 'Trechos fora do tema ou estrutura pouco clara'],
    ['1 (Muito Fraco)', '1-7 pts', 'Quase sem comunicação significativa'],
  ],

  vocabHeading: 'Vocabulário Essencial de TOEFL',
  vocabIntro: 'Estude palavras essenciais por categoria. Clique para ver o significado.',
  vocabShowAll: 'Mostrar tudo',
  vocabHideAll: 'Ocultar tudo',
  vocabReset: 'Redefinir',
  vocabClickToReveal: 'Clique para revelar o significado',
  vocabMotivation: 'Revisão consistente aumenta sua pontuação no TOEFL.',
  vocabMyWords: 'Meu Vocabulário',
  vocabAddWord: 'Adicionar Palavra',
  vocabAddWordPlaceholder: 'Digite uma palavra em inglês',
  vocabMyWordsEmpty: 'Nenhuma palavra adicionada ainda. Adicione a primeira acima.',
  vocabDeleteWord: 'Excluir',
  vocabLookingUp: 'Pesquisando...',
  vocabQuizTitle: 'Quiz de Vocabulário',
  vocabQuizDesc: 'Teste sinônimos e antônimos das palavras estudadas.',
  vocabQuizMode_synonym: 'Quiz de Sinônimos',
  vocabQuizMode_antonym: 'Quiz de Antônimos',
  vocabQuizMode_mixed: 'Quiz Misto',
  vocabQuizClose: 'Fechar',
  vocabQuizNoQuestions: 'Ainda não há itens suficientes nesta categoria.',
  vocabQuizBack: 'Voltar',
  vocabQuizResult: 'Resultado do Quiz',
  vocabQuizExcellent: 'Excelente!',
  vocabQuizGood: 'Ótimo trabalho. Mais um pouco de prática e você domina.',
  vocabQuizKeepGoing: 'Continue!',
  vocabQuizRetry: 'Tentar novamente',
  vocabQuizFindSynonym: 'Escolha o sinônimo da palavra abaixo',
  vocabQuizFindAntonym: 'Escolha o antônimo da palavra abaixo',
  vocabQuizNext: 'Próximo',
  vocabQuizFinish: 'Ver Resultado',
  vocabQuizStart: 'Iniciar Quiz',

  testPrevious: 'Anterior',
  testNext: 'Próximo',
  testQuestion: 'Questão',
  testQuestionPrompt: 'Leia a questão e escolha a melhor resposta.',
  testMarkAnswer: 'Marque o número da melhor resposta.',
  testSelect: 'Selecionar',
  testShowAnswer: 'Mostrar resposta e explicação',
  testCorrect: 'Correto!',
  testIncorrect: 'Incorreto.',
  testSubmit: 'Enviar Teste',
  testContinue: 'Continuar',

  resultsTitle: 'Resultado do Teste {0}',
  resultsTimeUsed: 'Tempo usado: {0}m {1}s',
  resultsEstimatedScore: 'Pontuação estimada (de 30)',
  resultsCorrect: 'Corretas',
  resultsIncorrect: 'Incorretas',

  // --- Auto-translated UI strings ---
  lcTitle: "Compreensão Auditiva",
  rcTitle: "Leitura",
  part1: "Leitura Acadêmica (20)",
  part2: "Conversas (10)",
  part3: "Palestras (18)",
  vocabLabel: "Vocabulário",
  tipsLabel: "Dicas e Estratégia",
  catLabel: "Teste Adaptativo CAT",
  footerCopyright: "© 2026 Power TOEFL. Todos os direitos reservados.",
  footerDisclaimer: "TOEFL® é uma marca registrada da ETS. Power TOEFL é uma plataforma independente e não é afiliada ou endossada pela ETS.",
  faqPageTitle: "Inscrição, Pontuação, Validade do TOEFL - FAQ 2026 | Power TOEFL",
  faqPageDesc: "Inscrição, conversão de pontuação, validade e estratégia de seção em uma página.",
  scoreChartPageTitle: "Conversão de Pontuação TOEFL 2026 - Verifique as Pontuações das Seções Instantaneamente | Power TOEFL",
  scoreChartPageDesc: "Conversão de pontuação por seção do TOEFL para Leitura, Compreensão Auditiva, Fala e Escrita. Insira as respostas corretas para uma pontuação estimada e orientação de meta.",
  scoreChartUnit: "",
  vocabPageTitle: "600 Palavras TOEFL de Alta Frequência - Significados e Exemplos | Power TOEFL",
  vocabPageDesc: "Aprenda 600 palavras TOEFL por categoria com significados e exemplos instantâneos.",
  vocabCatNaturalScience: "Ciências Naturais",
  vocabCatSocialScience: "Ciências Sociais",
  vocabCatHumanities: "Humanidades",
  vocabCatLifeScience: "Ciências Biológicas",
  vocabCatTechnology: "Tecnologia/Engenharia",
  vocabCatAcademicGeneral: "Acadêmico Geral",
  pricingTitle: "Preços Power TOEFL Pro — R$39,90/mês | Compare Gratuito vs Pro | 2026",
  pricingDesc: "Compare os planos Gratuito e Pro: perguntas ilimitadas com IA, estudo sem anúncios, desbloqueio completo de rodadas e ferramentas de análise premium.",
  pricingSaveBadge: "30% de desconto",
  pricingPerMonth: "mês",
  pricingSSL: "Pagamento seguro",
  pricingCard: "Pagamento com cartão",
  pricingPaymentSuccess: "Premium ativado com sucesso!",
  pricingPaymentCancelled: "O pagamento foi cancelado.",
  pricingLoginRequired: "É necessário fazer login.",
  pricingPaymentError: "Falha ao criar a sessão de checkout.",
  pricingCurrentPlan: "Plano atual",
  pricingFaqQ1: "Qual a diferença entre Grátis e Pro?",
  pricingFaqA1: "O plano Grátis inclui prática essencial de Leitura/Audição. O Pro adiciona testes simulados ilimitados com IA, feedback de IA para Fala/Escrita, análise de pontos fracos e estudo sem anúncios.",
  pricingFaqQ2: "Posso obter um reembolso?",
  pricingFaqA2: "Devido à natureza dos produtos digitais, em princípio não há reembolso. No entanto, o reembolso pode ser concedido excepcionalmente quando exigido por lei, em caso de cobrança duplicada, não prestação do serviço ou falha técnica grave.",
  pricingFaqQ3: "Como cancelo minha assinatura?",
  pricingFaqA3: "Você pode cancelar a qualquer momento em Minha Assinatura. O acesso permanece disponível até o final do período de cobrança atual.",
  pricingFaqQ4: "Qual a diferença entre Pro Vitalício e Pro Anual?",
  pricingFaqA4: "O Vitalício é uma compra única com acesso permanente. O Pro Anual é renovado anualmente.",
  grammarSystematic: "Aprendizagem sistemática de gramática",
  grammarBookTitle: "Livro de Gramática TOEFL",
  grammarBookDesc: "Aprenda 20 tópicos essenciais de gramática do TOEFL com exemplos práticos e exercícios.",
  grammarTestAfter: "Teste logo após estudar!",
  grammarTestAfterDesc: "Verifique como os pontos gramaticais aparecem em questões reais do TOEFL.",
  grammarMockTest: "Teste Simulado",
  grammarDoneTitle: "Concluiu o estudo de gramática?",
  grammarDoneDesc: "Aplique o que você aprendeu em um teste simulado. As respostas erradas são salvas automaticamente para revisão.",
  grammarStartRC: "Iniciar Teste Simulado de Leitura",
  grammarPracticePart5: "Prática de Gramática (Compreensão de Leitura)",
  grammarCourseName: "Guia Completo de Gramática TOEFL",
  grammarBreadcrumb: "Livro de Gramática",
  leaderboardTitle: "Classificação de Estudo",
  leaderboardWeekly: "Semanal",
  leaderboardMonthly: "Mensal",
  leaderboardLoading: "Carregando...",
  leaderboardEmpty: "Nenhum dado para este {periodo} ainda.",
  leaderboardEmptyWeek: "semana",
  leaderboardEmptyMonth: "Mês",
  leaderboardHint: "Resolva testes e entre automaticamente na lista!",
  leaderboardRank: "Classificação",
  leaderboardNickname: "Apelido",
  leaderboardSolved: "Resolvido",
  leaderboardAccuracy: "Precisão",
  leaderboardMe: "Eu",
  leaderboardMyRank: "🏅 Minha classificação: #{rank}",
  navReading: "Leitura",
  navListening: "Audição",
  vocabSynonyms: "Sinônimos",
  vocabAntonyms: "Antônimos",
  tipsLCButton: "Estratégia de Audição",
  tipsRCButton: "Estratégia de Leitura",
  practiceRelatedLinks: "📌 Conteúdo de estudo relacionado",
  practiceOtherParts: "Outras partes",
  practiceMockTestCTA: "Pratique com um simulado completo",
  practiceTipsLink: "Ver estratégias específicas da parte",
  practiceGrammarLink: "Estudar gramática",
  practiceNotFound: "Parte não encontrada.",
  practiceQuestionType: "Tipo de pergunta",
  practiceTips: "💡 Dicas de estratégia",
  practiceExamples: "📝 Perguntas de exemplo",
  practiceIntro: "📋 Visão geral da parte",
  practiceCommonTypes: "📊 Tipos de perguntas comuns",
  practiceStrategy: "🎯 Estratégias-chave",
  practiceRecommendedFor: "👤 Recomendado para",
  practiceFAQ: "❓ Perguntas frequentes",
  practiceCTA: "Pratique agora",
  practiceCTADesc: "Você pode praticar a Parte {0} em um ambiente de teste realista.",
  practiceStartTest: "Começar o simulado {0}",
  practiceQuestions: "Questões",
  practicePartSelect: "Selecionar parte",
  roundsTitle: "Rodadas do simulado",
  roundLabel: "Simulado TOEFL",
  roundUnit: "rodada",
  comingSoon: "Em breve",
  testLoginPrompt: "As notas de respostas erradas e os recursos de retomada exigem login.",
  testGoogleLogin: "Comece com o Google em 3 segundos",
  roundSelect: "Selecionar outra rodada",
  testAnswered: "Respondido",
  testSubmitTitle: "Enviar teste {0}?",
  testSubmitDesc: "Você respondeu {1} de {0} perguntas.",
  testUnanswered: "{0} perguntas não respondidas.",
  testCannotUndo: "Esta ação não pode ser desfeita.",
  testSubmitBtn: "Enviar",
  resultsAccuracy: "Precisão",
  resultsReview: "Revisar respostas",
  resultsYourAnswer: "Sua resposta: {0}",
  resultsCorrectAnswer: "Resposta correta: {0}",
  resultsNoAnswer: "Nenhuma resposta",
  resultsHome: "Início",
  resultsWrongNotes: "Respostas erradas",
  resultsRetry: "Tentar novamente",
  resultsShare: "Compartilhar resultados",
  resultsShareText: "Meu score estimado no TOEFL {0} é {1}! ({2}/{3} corretas, {4}% de precisão) Teste suas habilidades gratuitamente com o Power TOEFL!",
  resultsShareCopied: "Resultados copiados para a área de transferência!",
  resultsNoResults: "Nenhum resultado de teste.",
  resultsGoHome: "Ir para a página inicial",
  resultsSaved: "{0} respostas erradas salvas em suas respostas erradas",
  wrongAnswersTitle: "Respostas erradas",
  wrongAnswersSaved: "Itens salvos",
  wrongAnswersHome: "Início",
  wrongAnswersPracticeAll: "Praticar todas",
  wrongAnswersAll: "Todas",
  wrongAnswersNoItems: "Ainda não há respostas erradas. Faça um teste primeiro!",
  wrongAnswersYourAnswer: "Sua resposta: {0}",
  wrongAnswersCorrectIs: "Resposta correta: {0}",
  wrongAnswersReviewed: "Revisadas",
  wrongAnswersRemoved: "Removido das respostas erradas",
  wrongAnswersPracticeMode: "Modo de prática",
  wrongAnswersCorrectMsg: "Correto!",
  wrongAnswersIncorrectMsg: "Incorreto. Resposta correta: {0}",
  wrongAnswersNextQuestion: "Próxima pergunta",
  wrongAnswersFinish: "Finalizar prática",
  wrongAnswersExitPractice: "Sair da prática",
  wrongAnswersPracticeComplete: "Prática concluída!",
  wrongAnswersNoPractice: "Não há respostas erradas para praticar",
  wrongAnswersLimitNotice: "Apenas as 500 respostas erradas mais recentes são exibidas.",
  privacyPageTitle: "Política de Privacidade — Power TOEFL",
  privacyPageDesc: "Política de Privacidade do Power TOEFL.",
  privacyHeading: "Política de Privacidade",
  privacyLastUpdated: "Última atualização: 29 de março de 2026",
  privacyS1Title: "1. Informações pessoais coletadas",
  privacyS1Body: "O Power TOEFL coleta seu endereço de e-mail, nome e foto de perfil quando você faz login com o Google para fornecer o serviço. Ao realizar pagamentos, as informações de pagamento são processadas por meio de provedores de pagamento (Dodo Payments/PayPal); não armazenamos detalhes de cartões de pagamento diretamente.",
  privacyS2Title: "2. Finalidade de uso",
  privacyS2Body: "Os dados pessoais coletados são utilizados apenas para salvar respostas erradas, acompanhar o progresso dos estudos, gerenciar assinaturas, suporte ao cliente e melhorar o serviço.",
  privacyS3Title: "3. Retenção e exclusão de dados",
  privacyS3Body: "Quando um usuário exclui sua conta, os dados pessoais são excluídos imediatamente. Os registros de pagamento são retidos por até 5 anos, conforme exigido pela legislação tributária, e depois excluídos. Se outras leis exigirem a retenção, os dados serão mantidos pelo período exigido e depois excluídos.",
  privacyS4Title: "4. Divulgação a terceiros",
  privacyS4Body: "Para processar pagamentos, compartilhamos as informações mínimas necessárias (e-mail) com a Dodo Payments (Comerciante Registrado) ou PayPal. Não fornecemos dados pessoais de usuários a terceiros, exceto quando exigido por lei.",
  privacyS5Title: "5. Cookies e anúncios",
  privacyS5Body: "Este site veicula anúncios via Google AdSense e usa cookies para essa finalidade. Os cookies podem ser gerenciados nas configurações do seu navegador. Para detalhes sobre os cookies de publicidade do Google, consulte a Política de Privacidade do Google.",
  privacyS6Title: "6. Transferências internacionais de dados",
  privacyS6Body: "Este serviço utiliza servidores localizados no exterior, e os dados podem ser transferidos internacionalmente para processamento de pagamentos. Protegemos os dados pessoais com medidas de segurança apropriadas.",
  privacyS7Title: "7. Direitos do usuário",
  privacyS7Body: "Os usuários podem solicitar acesso, correção ou exclusão de seus dados pessoais a qualquer momento. Residentes da UE/EEE têm direitos adicionais sob o GDPR. Para excluir sua conta, faça logout e entre em contato conosco.",
  privacyS8Title: "8. Contato",
  privacyS8Body: "Para dúvidas sobre privacidade, entre em contato com skdaks0731@gmail.com.",
  termsPageTitle: "Termos de Serviço — Power TOEFL",
  termsPageDesc: "Termos de Serviço do Power TOEFL.",
  termsHeading: "Termos de Serviço",
  termsLastUpdated: "Última atualização: 29 de março de 2026",
  termsS1Title: "1. Visão geral do serviço",
  termsS1Body: "Power TOEFL é uma plataforma de aprendizado online para preparação para o TOEFL, operada por ddookddak (nosso nome comercial legal registrado). Oferecemos recursos gratuitos e assinaturas premium pagas (Pro/Vitalícia) que incluem simulados, prática específica por parte, geração de perguntas por IA e notas de respostas erradas.",
  termsS2Title: "2. Elegibilidade",
  termsS2Body: "O serviço está disponível para usuários com idade igual ou superior a 14 anos. Alguns recursos (notas de respostas erradas, prática com IA, etc.) exigem login com conta Google, e os recursos premium exigem uma assinatura paga.",
  termsS3Title: "3. Propriedade intelectual",
  termsS3Body: "O conteúdo deste site (perguntas, design, código, etc.) é de propriedade do Power TOEFL. TOEFL é uma marca registrada da ETS; este site não é afiliado à ETS.",
  termsS4Title: "4. Serviços pagos e pagamentos",
  termsS4Body: "As assinaturas premium são processadas por meio de serviços de pagamento de terceiros (Dodo Payments/PayPal). As taxas de assinatura são cobradas automaticamente ou como um pagamento único, dependendo do plano selecionado (mensal/anual/vitalício). Os preços podem incluir IVA; o valor final é mostrado no checkout. Consulte a política de reembolso separada para detalhes sobre reembolsos.",
  termsS5Title: "5. Isenção de responsabilidade",
  termsS5Body: "As pontuações de simulados e materiais de estudo fornecidos por este serviço são apenas para referência e não garantem os resultados reais do TOEFL. Não somos responsáveis por danos diretos ou indiretos resultantes do uso do serviço.",
  termsS6Title: "6. Conduta proibida",
  termsS6Body: "Você não pode copiar ou distribuir perguntas sem permissão, sobrecarregar o sistema, compartilhar contas com outras pessoas ou se envolver em outras atividades ilegais.",
  termsS7Title: "7. Alterações e suspensão do serviço",
  termsS7Body: "O operador pode alterar ou suspender o serviço sem aviso prévio e não é obrigado a fornecer compensação.",
  termsS8Title: "8. Cancelamento da assinatura",
  termsS8Body: "As assinaturas pagas podem ser canceladas a qualquer momento. Após o cancelamento, os recursos premium permanecem disponíveis até o final do período pago, após o qual a conta retornará ao plano gratuito.",
  termsS9Title: "9. Alterações nos termos",
  termsS9Body: "Estes termos podem ser atualizados conforme necessário; as alterações serão publicadas no site. O uso contínuo do serviço após as alterações constitui aceitação dos termos atualizados.",
  refundPageTitle: "Política de Reembolso — Power TOEFL",
  refundPageDesc: "Política de reembolso da assinatura premium Power TOEFL.",
  refundHeading: "Política de Reembolso",
  refundLastUpdated: "Última atualização: 15 de abril de 2026",
  refundS1Title: "1. Princípio de reembolso",
  refundS1Body: "Devido à natureza dos produtos digitais, em princípio não há reembolso.",
  refundS2Title: "2. Casos excepcionais de reembolso",
  refundS2Body: "No entanto, o reembolso pode ser concedido excepcionalmente quando exigido por lei, em caso de cobrança duplicada, não prestação do serviço ou falha técnica grave.",
  refundS3Title: "3. Como entrar em contato",
  refundS3Body: "Para dúvidas sobre reembolso, use o canal de suporte/feedback. Contato: skdaks0731@gmail.com",
  refundS4Title: "4. Cancelamento da assinatura",
  refundS4Body: "Assinaturas pagas podem ser canceladas a qualquer momento. Após o cancelamento, o acesso premium permanece até o fim do período de cobrança atual e não haverá cobranças adicionais.",
  refundS5Title: "",
  refundS5Body: "",
  refundS6Title: "",
  refundS6Body: "",
  footerPrivacy: "Política de Privacidade",
  footerTerms: "Termos de Serviço",
  footerRefund: "Política de Reembolso",
  footerAbout: "Sobre",
  footerGuide: "Guia de Estudo",
  resumeTest: "Retomar",
  resumeDesc: "{0} Rodada {1} — {2}/{3} questões",
  progressLabel: "Progresso",
  timerLabel: "Tempo restante",
  timeUp: "Tempo esgotado!",
  navHome: "Início",
  navSettings: "Dicas e Estratégias",
  grammarChapter: "Capítulo",
  aiPracticeTitle: "Gerar perguntas ilimitadas de TOEFL com IA — escolha parte e dificuldade para perguntas instantâneas | Power TOEFL",
  aiPracticeDesc: "Selecione uma parte e dificuldade e a IA gerará perguntas TOEFL instantaneamente. Perguntas de prática gratuitas com explicações automáticas — obtenha novas perguntas todos os dias.",
  aiPracticeH1: "✨ Gerador de Perguntas TOEFL com IA",
  aiPracticeSub: "A IA gera perguntas TOEFL em tempo real na dificuldade escolhida.",
  aiPartLabel: "Parte",
  aiDiffLabel: "Dificuldade",
  aiBeginner: "Iniciante (1.0–2.5)",
  aiIntermediate: "Intermediário (3.0–4.5)",
  aiAdvanced: "Avançado (5.0–6.0)",
  aiGenerate: "Gerar perguntas",
  aiGenerating: "Gerando...",
  aiRemainingToday: "{0} restantes este mês",
  aiLimitReached: "Você usou todos os créditos de IA para este mês",
  aiLimitUpgrade: "Compre mais créditos ou faça upgrade do seu plano!",
  aiUpgrade: "Upgrade",
  aiListenPrompt: "🔊 Para perguntas de Listening, ouça o áudio enquanto responde",
  aiPlayAudio: "Reproduzir áudio",
  aiStopAudio: "Parar",
  aiCorrect: "✅ Correto!",
  aiWrong: "❌ Incorreto.",
  aiCorrectAnswer: "Resposta correta: {0}",
  aiPrev: "Anterior",
  aiNext: "Próxima",
  aiNewQuestions: "Novas perguntas",
  aiEmptyTitle: "Gerar perguntas com IA",
  aiEmptyDesc: "Selecione uma parte e dificuldade, depois pressione \"Gerar perguntas\".",
  aiLoadingMain: "A IA está gerando e validando perguntas...",
  aiLoadingSub: "Leva cerca de 10 a 20 segundos",
  statsTitle: "Estatísticas de Estudo TOEFL — Power TOEFL",
  statsDesc: "Veja a precisão do seu quiz de gramática TOEFL, o status de revisão de respostas erradas e outras estatísticas de estudo rapidamente.",
  statsH1: "📊 Estatísticas de Estudo",
  statsLoginPrompt: "Faça login para ver suas estatísticas de estudo.",
  statsTotalQuizzes: "Total de testes",
  statsTotalQuestions: "Total de perguntas",
  statsAccuracy: "Precisão",
  statsLast7Days: "Últimos 7 dias",
  statsWrongSummary: "Resumo de Dúvidas",
  statsViewAll: "Ver respostas erradas",
  statsTotalWrong: "Total de respostas erradas",
  statsReviewed: "Revisadas",
  statsPending: "Pendente de revisão",
  statsTopicAccuracy: "Precisão por tópico gramatical",
  statsAttempts: "{0} tentativas",
  statsEmpty: "Nenhum registro de estudo ainda. Faça um teste de gramática!",
  statsStartGrammar: "Iniciar estudo de gramática",
  testLCTitle: "Simulado de Leitura TOEFL gratuito — leitura de texto acadêmico | 2026",
  testLCDesc: "Simulado de Leitura TOEFL gratuito e atualizado para 2026. 20 perguntas baseadas em textos acadêmicos. Respostas erradas salvas automaticamente.",
  testRCTitle: "Simulado de Audição TOEFL gratuito — conversas e palestras | 2026",
  testRCDesc: "Simulado de Audição TOEFL gratuito e atualizado para 2026. 28 perguntas de conversas e palestras. Explicações com IA e anotações de respostas erradas fornecidas.",
  reviewTitle: "Revisão de hoje",
  reviewDesc: "Sistema de revisão inteligente baseado na Curva do Esquecimento de Ebbinghaus",
  reviewSubtitle: "Revise nos momentos ideais de acordo com a curva do esquecimento",
  reviewRemaining: "Revisões restantes",
  reviewProgress: "Progresso da revisão",
  reviewCompleted: "🎉 Revisão de hoje completa!",
  reviewCompletedDesc: "{0} perguntas revisadas",
  reviewEmpty: "Nenhum item para revisar hoje",
  reviewEmptyDesc: "Você completou todas as revisões ou ainda não há respostas erradas para revisar.",
  reviewStage: "Estágio {0}",
  reviewNextInterval: "Intervalo de {0} dias",
  reviewCorrect: "Correto! Passe para a próxima etapa.",
  reviewWrong: "Incorreto. Reiniciando na etapa 1.",
  reviewNextReview: "Próxima revisão: em {0} dias",
  reviewResetMsg: "Incorreto – você revisará novamente em 1 dia.",
  reviewNext: "Próxima pergunta",
  reviewFinish: "Finalizar",
  reviewHowItWorks: "Método de revisão Ebbinghaus",
  reviewDaysLater: "{0} dias depois",
  reviewExplanation: "Itens incorretos são revisados em intervalos de 1 → 3 → 7 → 14 → 30 → 60 dias. Respostas corretas avançam para a próxima etapa; respostas incorretas retornam à etapa 1.",
  notifTitle: "Notificações",
  notifEmpty: "Nenhuma nova notificação",
  notifMarkAllRead: "Marcar todas como lidas",
  timeJustNow: "Agora mesmo",
  timeMinutes: "Há {0} minutos",
  timeHours: "Há {0} horas",
  timeDays: "Há {0} dias",
  scoreCardEstimated: "Pontuação estimada",
  scoreCardCorrect: "Corretas",
  scoreCardIncorrect: "Incorretas",
  scoreCardAccuracy: "Precisão",
  pushTitle: "Receba notificações de estudo",
  pushDesc: "Nós o notificaremos sobre horários de revisão, sequências e muito mais.",
  pushEnable: "Ativar notificações",
  navReview: "Revisão",
  navStats: "Estatísticas",
  navSubscription: "Assinatura",
  roundDetailHeading: "Simulado Completo do TOEFL",
  roundDetailOtherRounds: "Ver outras rodadas",
  roundSuffix: "rodada",
  footer7DayPlan: "Plano de estudo de 7 dias",
  footerTrapPatterns: "Padrões de armadilha",
  pwaAddToHome: "📱 Adicionar à tela inicial",
  pwaAddToHomeDesc: "Inicie como um aplicativo! Estude offline também",
  pwaInstall: "Instalar",
  pwaIOSGuide: "Compartilhar → Adicionar à tela inicial",
  aiQuizTitle: "🤖 Perguntas de Prática Personalizadas por IA",
  aiQuizDesc: "Perguntas de gramática TOEFL geradas por IA",
  aiQuizGenerateDesc: "A IA gera 5 perguntas de gramática estilo TOEFL em tempo real.",
  aiQuizGenerate: "Gerar perguntas de IA",
  aiQuizGenerating: "🤖 A IA está gerando perguntas...",
  aiQuizGeneratingTime: "Leva cerca de 5 a 10 segundos",
  aiQuizNew: "Novas perguntas",
  aiQuizStats: "Estatísticas cumulativas:",
  aiQuizTimes: "vezes",
  aiQuizCheckAnswers: "Verificar respostas",
  aiQuizPerfect: "🎉 Perfeito!",
  aiQuizCorrectCount: "Correto",
  aiQuizSaving: "Salvando resultados...",
  aiQuizTryNew: "Experimentar novas perguntas",
  aiQuizError: "Falha ao gerar perguntas de IA. Por favor, tente novamente.",
  tipsDetailStrategy: "Estratégia detalhada",
  subLoginRequired: "Login necessário.",
  grammarHome: "Início",
  grammarExamples: "Frases de exemplo",
  grammarTestKnowledge: "📝 Teste de habilidade",
  grammarTestKnowledgeDesc: "Experimente perguntas reais relacionadas à gramática que você acabou de aprender!",
  grammarCheckAnswers: "Verificar respostas",
  grammarPerfect: "🎉 Perfeito!",
  grammarCorrectCount: "Correto",
  grammarMockCTA: "🔥 Verifique suas habilidades com um simulado completo!",
  grammarMockCTADesc: "Simulado completo RC com 100 questões + anotações automáticas das respostas erradas",
  grammarStartRCMock: "Iniciar simulado de RC",
  grammarPractice5: "Prática de leitura",
  grammarTestInPractice: "Verifique na prática!",
  grammarTestInPracticeDesc: "Veja como os pontos gramaticais aparecem em testes TOEFL reais.",
  grammarRelated: "📚 Gramática relacionada",
  wrongAnswersGrammarAI: "Gramática IA",
  streakDays: "dias",
  streakLabel: "Sequência de estudos",
  streak7: "Sequência de 7 dias!",
  streak14: "Sequência de 2 semanas!",
  streak30: "Incrível! Sequência de 30 dias!",
  reviewItems: "itens",
  reviewTodayLabel: "Perguntas de revisão de hoje",
  reviewGoLabel: "📚 Iniciar revisão →",
  loadingQuestions: "Carregando perguntas...",
  tipsCoreTips: "Dicas essenciais",
  tipsStrategy: "Estratégia",
  tipsCTA: "Aplique estas estratégias na prática!",
  testScrollHint: "Role para ver a pergunta e as opções",
  testPart1Label: "Leitura Acadêmica",
  testPart2Title: "Conversas",
  testPart2Desc: "Ouça o áudio e escolha a resposta correta",
  testPart3Label: "Palestras",
  creditBuyBtn: "Comprar créditos",
  creditBuyTitle: "Comprar créditos de IA",
  creditBuyDesc: "Compre créditos extras para feedback de IA de Speaking/Writing e prática de IA.",
  creditBuyError: "Falha ao iniciar o pagamento",
  creditBuyNote: "Pagamento via PayPal. Os créditos são adicionados imediatamente após a conclusão do pagamento.",
  creditUnit: "créditos",
  navFAQ: "FAQ",
} as typeof en;

export default ptBR;
